import { render, staticRenderFns } from "./CarDetails3.vue?vue&type=template&id=c5ffb290&scoped=true"
import script from "./CarDetails3.vue?vue&type=script&lang=js"
export * from "./CarDetails3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ffb290",
  null
  
)

export default component.exports